( () => {
	const BLOCK_CLASS = 'wp-block-phrase-com-countdown';
	const blocks = document.querySelectorAll< HTMLDivElement >( `.${ BLOCK_CLASS }` );
	if ( ! blocks.length ) {
		return;
	}

	const MINUTE_IN_SECONDS = 60;
	const HOUR_IN_SECONDS = 60 * MINUTE_IN_SECONDS;
	const DAY_IN_SECONDS = 24 * HOUR_IN_SECONDS;

	blocks.forEach( ( block ) => {
		const date = parseInt( block.dataset.date || '0' );
		if ( ! date ) {
			return;
		}

		const daysElement = block.querySelector(
			'.wp-block-phrase-com-countdown-days .wp-block-phrase-com-countdown__number'
		);
		const hoursElement = block.querySelector(
			'.wp-block-phrase-com-countdown-hours .wp-block-phrase-com-countdown__number'
		);
		const minutesElement = block.querySelector(
			'.wp-block-phrase-com-countdown-minutes .wp-block-phrase-com-countdown__number'
		);
		const secondsElement = block.querySelector(
			'.wp-block-phrase-com-countdown-seconds .wp-block-phrase-com-countdown__number'
		);

		if ( ! daysElement && ! hoursElement && ! minutesElement && ! secondsElement ) {
			return;
		}

		const updateRemainingTime = (
			timestamp: number,
			intervalId: ReturnType< typeof setInterval > | null = null
		) => {
			const now = new Date();
			const target = new Date( timestamp * 1000 );
			const diff = target.getTime() - now.getTime();

			if ( diff <= 0 ) {
				if ( intervalId ) {
					clearInterval( intervalId );
				}

				if ( daysElement ) {
					daysElement.textContent = '0';
				}

				if ( hoursElement ) {
					hoursElement.textContent = '00';
				}

				if ( minutesElement ) {
					minutesElement.textContent = '00';
				}

				if ( secondsElement ) {
					secondsElement.textContent = '00';
				}
				return;
			}

			if ( daysElement ) {
				const days = Math.floor( diff / ( 1000 * DAY_IN_SECONDS ) );
				daysElement.textContent = days.toString();
			}

			if ( hoursElement ) {
				const hours = Math.floor(
					( diff % ( 1000 * DAY_IN_SECONDS ) ) / ( 1000 * HOUR_IN_SECONDS )
				);
				hoursElement.textContent = hours.toString().padStart( 2, '0' );
			}

			if ( minutesElement ) {
				const minutes = Math.floor(
					( diff % ( 1000 * HOUR_IN_SECONDS ) ) / ( 1000 * MINUTE_IN_SECONDS )
				);
				minutesElement.textContent = minutes.toString().padStart( 2, '0' );
			}

			if ( secondsElement ) {
				const seconds = Math.floor( ( diff % ( 1000 * MINUTE_IN_SECONDS ) ) / 1000 );
				secondsElement.textContent = seconds.toString().padStart( 2, '0' );
			}
		};

		updateRemainingTime( date );
		block.classList.add( 'is-initialized' );
		const intervalId = setInterval( () => {
			updateRemainingTime( date, intervalId );
		}, 1000 );
	} );
} )();
